import React, { createContext, useState, useEffect, useMemo } from "react";
import useDefaultCustomer from "../components/useDefaultCustomer";

export const CustomerIdContext = createContext();

export default function CustomerIdProvider({ children }) {
  const defaultCustomerId = useDefaultCustomer();
  const [selectedCustomerId, setSelectedCustomerId] =
    useState(defaultCustomerId);

  // Avoid unnecessary state updates
  useEffect(() => {
    setSelectedCustomerId(defaultCustomerId);
  }, [defaultCustomerId]);

  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({ selectedCustomerId, setSelectedCustomerId }),
    [selectedCustomerId]
  );

  return (
    <CustomerIdContext.Provider value={contextValue}>
      {children}
    </CustomerIdContext.Provider>
  );
}
